var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1792 0H15.1137C7.18896 0 0.764648 6.4262 0.764648 14.3533V14.4188C0.764648 22.346 7.18896 28.7722 15.1137 28.7722H15.1792C23.104 28.7722 29.5283 22.346 29.5283 14.4188V14.3533C29.5283 6.4262 23.104 0 15.1792 0Z",
    fill: "#040742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5968 5.85352H10.6965C8.23765 5.85352 6.2373 7.85445 6.2373 10.314V18.4589C6.2373 20.9185 8.23765 22.9194 10.6965 22.9194H19.5968C22.0557 22.9194 24.056 20.9185 24.056 18.4589V10.314C24.056 7.85445 22.0557 5.85352 19.5968 5.85352ZM7.81038 10.314C7.81038 8.72237 9.10531 7.42705 10.6965 7.42705H19.5968C21.188 7.42705 22.483 8.72237 22.483 10.314V18.4589C22.483 20.0506 21.188 21.3459 19.5968 21.3459H10.6965C9.10531 21.3459 7.81038 20.0506 7.81038 18.4589V10.314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1469 18.5344C17.4334 18.5344 19.2947 16.6736 19.2947 14.3854C19.2947 12.0971 17.4344 10.2363 15.1469 10.2363C12.8593 10.2363 10.999 12.0971 10.999 14.3854C10.999 16.6736 12.8593 18.5344 15.1469 18.5344ZM15.1469 11.8109C16.5667 11.8109 17.7216 12.9661 17.7216 14.3864C17.7216 15.8067 16.5667 16.9619 15.1469 16.9619C13.727 16.9619 12.5721 15.8067 12.5721 14.3864C12.5721 12.9661 13.727 11.8109 15.1469 11.8109Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6781 10.9067C20.2938 10.9067 20.7957 10.4057 20.7957 9.7888C20.7957 9.17189 20.2948 8.6709 19.6781 8.6709C19.0614 8.6709 18.5605 9.17189 18.5605 9.7888C18.5605 10.4057 19.0614 10.9067 19.6781 10.9067Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.a894c37a62080dec86ec65921d255a78.svg";
export { ForwardRef as ReactComponent };